import {BaseAttribute, BaseAttributeOptions} from './BaseAttribute';

export type JsonObjectAttributeOptions = BaseAttributeOptions;

// Attribute for arbitrary JSON object fields
export class JsonObjectAttribute extends BaseAttribute {
  constructor(options: JsonObjectAttributeOptions = {}) {
    super(options);
  }

  // Input type that is used if attribute is used in edit mode
  get inputType(): string {
    return 'json';
  }

  getInitialValue(): unknown {
    if (this.creationValue !== undefined && this.creationValue !== null) {
      return this.creationValue;
    }
    return {};
  }
}
